import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { countries } from '@material-dev/country-data';

const CountryName = ({ code }) => (
  <Fragment>{code && countries[code] && countries[code].name ? countries[code].name : code}</Fragment>
);

CountryName.propTypes = {
  code: PropTypes.string
};

export default CountryName;



// WEBPACK FOOTER //
// ./src/app/admin/components/CountryName/index.js